import Terminal from '../components/Rooms/Terminal'

let routes = {
  path: '/terminal',
  component: resolve => require(['../components/layout/Terminal'], resolve),
  children: [
    {
      path: '/terminal/:id?',
      name: 'Terminal',
      component: Terminal
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/terminal.js